import { Box } from '@mui/system';
import { LayoutItem } from 'api/models';
import { get } from 'object-path';
import LayoutFieldRow from './LayoutFieldRow';
import { useRecoilValue } from 'recoil';
import { layoutSelector } from 'state';
import { getLayoutItemStyles } from 'routes/FormTemplateEditor/FormEditor/utils';

interface LayoutFieldTemplateProps {
  parentPath: string;
  editDisabled?: boolean;
  index: number;
}

export function LayoutField({
  parentPath,
  editDisabled,
  index,
}: LayoutFieldTemplateProps) {
  const path = `${parentPath}.${index}`;
  const rowPath = `${parentPath}.${index}.children`;
  const layout = useRecoilValue(layoutSelector);

  const rows = get(layout, rowPath) as LayoutItem[];

  return (
    <Box
      sx={{
        ...getLayoutItemStyles(get(layout, `${path}.layoutOptions.style`)),
        maxWidth: '100%',
      }}
    >
      {rows.map((row, rowIndex) => (
        <LayoutFieldRow
          key={`layout-field-row-${row.id}`}
          row={row}
          rowIndex={rowIndex}
          path={path}
          disabled={editDisabled ?? false}
        />
      ))}
    </Box>
  );
}
